import { action, createRequestTypes } from './base';

export const customerActionTypes = {
  CREATE_CUSTOMER: createRequestTypes('CREATE_CUSTOMER'),
  GET_CUSTOMER_BY_ID: createRequestTypes('GET_CUSTOMER_BY_ID'),
  GET_CUSTOMERS: createRequestTypes('GET_CUSTOMERS'),
  UPDATE_CUSTOMER: createRequestTypes('UPDATE_CUSTOMER'),
  GET_ORG_CUSTOMERS: createRequestTypes('GET_ORG_CUSTOMERS'),
  GET_BULK_UPLOAD_CUSTOMER_META_DATA: createRequestTypes('GET_BULK_UPLOAD_CUSTOMER_META_DATA'),
  BULK_UPLOAD_CUSTOMER: createRequestTypes('BULK_UPLOAD_CUSTOMER'),
  BULK_UPDATE_CUSTOMER: createRequestTypes('BULK_UPDATE_CUSTOMER'),
  GET_TALLY_CUSTOMERS: createRequestTypes('GET_TALLY_CUSTOMERS'),
};

/**
 *
 */
class CustomerActions {
  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  createCustomer = (payload, callback) => action(customerActionTypes.CREATE_CUSTOMER.REQUEST, {
    payload,
    callback,
  });

  /**
   *
   * @param createCustomerLoading
   * @return {{type: *}}
   */
  createCustomerLoading = (createCustomerLoading) => action(customerActionTypes.CREATE_CUSTOMER.LOADING, {
    createCustomerLoading,
  })

  /**
   *
   * @param createdCustomer
   * @return {{type: *}}
   */
  createCustomerSuccess = (createdCustomer) => action(customerActionTypes.CREATE_CUSTOMER.SUCCESS, {
    createdCustomer,
  })

  /**
   * @param page
   * @param keyword
   * @param orgId
   * @param limit
   * @param customerId
   * @param tenantSellerId
   * @param callback
   * @param tenantId
   * @param accountManagerIds
   * @return {{type: *}}
   */
  getCustomers = (keyword, tenantId, page, limit, customerId, callback, accountManagerIds, selectedCustomerIds, excludeCustomerIds, advanceFilters) => action(customerActionTypes.GET_CUSTOMERS.REQUEST, {
    keyword,
    tenantId,
    page,
    limit,
    customerId,
    callback,
    accountManagerIds,
    selectedCustomerIds,
    excludeCustomerIds,
    advanceFilters
  });

  /**
   *
   * @param getCustomersLoading
   * @return {{type: *}}
   */
  getCustomersLoading = (getCustomersLoading) => action(customerActionTypes.GET_CUSTOMERS.LOADING, {
    getCustomersLoading,
  })

  /**
   *
   * @param customers
   * @return {{type: *}}
   */
  getCustomersSuccess = (customers) => action(customerActionTypes.GET_CUSTOMERS.SUCCESS, {
    customers,
  })

  /**
   * @param customerId
   * @param tenantId
   * @return {{type: *}}
   */
  getCustomerById = (customerId, tenantId) => action(customerActionTypes.GET_CUSTOMER_BY_ID.REQUEST, {
    customerId,
    tenantId,
  })

  /**
   *
   * @param getCustomerByIdLoading
   * @return {{type: *}}
   */
  getCustomerByIdLoading = (getCustomerByIdLoading) => action(customerActionTypes.GET_CUSTOMER_BY_ID.LOADING, {
    getCustomerByIdLoading,
  });

  /**
   *
   * @param selectedCustomer
   * @return {{type: *}}
   */
  getCustomerByIdSuccess = (selectedCustomer) => action(customerActionTypes.GET_CUSTOMER_BY_ID.SUCCESS, {
    selectedCustomer,
  });

  /**
   * @param payload
   * @param callback
   * @param history
   * @return {{type: *}}
   */
  updateCustomer = (payload, callback) => action(customerActionTypes.UPDATE_CUSTOMER.REQUEST, {
    payload,
    callback,
  });

  /**
   *
   * @param updateCustomerLoading
   * @return {{type: *}}
   */
  updateCustomerLoading = (updateCustomerLoading) => action(customerActionTypes.UPDATE_CUSTOMER.LOADING, {
    updateCustomerLoading,
  })

  /**
   *
   * @param updatedCustomer
   * @return {{type: *}}
   */
  updateSellerSuccess = (updatedCustomer) => action(customerActionTypes.UPDATE_CUSTOMER.SUCCESS, {
    updatedCustomer,
  })

  // get all org customers
  getOrgCustomers = (keyword, page, limit, isArchiveCustomer) => action(customerActionTypes.GET_ORG_CUSTOMERS.REQUEST, {
    keyword,
    page,
    limit,
    isArchiveCustomer,
  });

  getOrgCustomersLoading = (getOrgCustomersLoading) => action(customerActionTypes.GET_ORG_CUSTOMERS.LOADING, {
    getOrgCustomersLoading,
  })

  getOrgCustomersSuccess = (orgCustomers) => action(customerActionTypes.GET_ORG_CUSTOMERS.SUCCESS, {
    orgCustomers,
  })

  /**
   *
   * @returns {{type: *}}
   */
  getBulkUploadCustomerMetadata = () => action(customerActionTypes.GET_BULK_UPLOAD_CUSTOMER_META_DATA.REQUEST, {})

  /**
   *
   * @param getBulkUploadCustomerMetadataLoading
   * @returns {{type: *}}
   */
  getBulkUploadCustomerMetadataLoading = (getBulkUploadCustomerMetadataLoading) => action(customerActionTypes.GET_BULK_UPLOAD_CUSTOMER_META_DATA.LOADING, {
    getBulkUploadCustomerMetadataLoading,
  })

  /**
   *
   * @param bulkUploadCustomerMetadata
   * @returns {{type: *}}
   */
  getBulkUploadCustomerMetadataSuccess = (bulkUploadCustomerMetadata) => action(customerActionTypes.GET_BULK_UPLOAD_CUSTOMER_META_DATA.SUCCESS, {
    bulkUploadCustomerMetadata,
  })

  /**
   *
   * @param payload
   * @param callback
   * @returns {{type: *}}
   */
  bulkUploadCustomers = (payload, callback) => action(customerActionTypes.BULK_UPLOAD_CUSTOMER.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param bulkUploadCustomersLoading
   * @returns {{type: *}}
   */
  bulkUploadCustomersLoading = (bulkUploadCustomersLoading) => action(customerActionTypes.BULK_UPLOAD_CUSTOMER.LOADING, {
    bulkUploadCustomersLoading,
  })

  /**
   *
   * @param bulkUploadResponse
   * @returns {{type: *}}
   */
  bulkUploadCustomersSuccess = (bulkUploadResponse) => action(customerActionTypes.BULK_UPLOAD_CUSTOMER.SUCCESS, {
    bulkUploadResponse,
  })

  /**
   *
   * @param bulkUploadError
   * @returns {{type: *}}
   */
  bulkUploadCustomersError = (bulkUploadError) => action(customerActionTypes.BULK_UPLOAD_CUSTOMER.ERROR, {
    bulkUploadError,
  })

  /**
  *
  * @param payload
  * @param callback
  * @returns {{type: *}}
  */
  bulkUpdateCustomers = (payload, callback) => action(customerActionTypes.BULK_UPDATE_CUSTOMER.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param bulkUpdateCustomersLoading
   * @returns {{type: *}}
   */
  bulkUpdateCustomersLoading = (bulkUpdateCustomersLoading) => action(customerActionTypes.BULK_UPDATE_CUSTOMER.LOADING, {
    bulkUpdateCustomersLoading,
  })

  /**
   *
   * @param bulkUpdateResponse
   * @returns {{type: *}}
   */
  bulkUpdateCustomersSuccess = (bulkUpdateResponse) => action(customerActionTypes.BULK_UPDATE_CUSTOMER.SUCCESS, {
    bulkUpdateResponse,
  })

  /**
   *
   * @param bulkUpdateError
   * @returns {{type: *}}
   */
  bulkUpdateCustomersError = (bulkUpdateError) => action(customerActionTypes.BULK_UPDATE_CUSTOMER.ERROR, {
    bulkUpdateError,
  })

  getTallyCustomers = (itId, orgId, searchKeyword, callback, selectedCustomer) => action(customerActionTypes.GET_TALLY_CUSTOMERS.REQUEST, {
    itId, orgId, searchKeyword, callback, selectedCustomer
  })

  /**
   *
   * @param getTallyCustomersLoading
   * @return {{type: *}}
   */
  getTallyCustomersLoading = (getTallyCustomersLoading) => action(customerActionTypes.GET_TALLY_CUSTOMERS.LOADING, {
    getTallyCustomersLoading,
  })

  /**
   *
   * @param tallyCustomers
   * @return {{type: *}}
   */
  getTallyCustomersSuccess = (tallyCustomers) => action(customerActionTypes.GET_TALLY_CUSTOMERS.SUCCESS, {
    tallyCustomers,
  })
}
export default new CustomerActions();
